import {
    TableContainer,
    Paper,
    TableHead,
    TableRow,
    TableBody,
    Button,
  } from "@mui/material";
import { CustomTableRowTR, StyledTable, TableData, TableHeader, TableWrapper } from "../../styles/commonStyles";
  import { formatDateTimeWithSeconds } from '../../utils/DateTimeUtils';
  import React, { useState } from "react";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import EventBus from "../../EventBus";
import ChefForPartyService from "../../services/ChefForPartyService";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import { PaymentLinkDailog } from "../Common/PaymentLinksDailogs";
import { useLocation } from 'react-router-dom';
import ChefForPartyRefundDailog from "../Common/ChefForPartyRefundDailog";
import EditAmountChefForParty from "../Common/EditAmountChefForParty";
import {PaymentStatusEnum} from "../../enums/PaymentStatusEnum";
import ChefForPartStatusEnum from "../../enums/ChefForPartStatusEnum";

  const ChefForPartyOrderList = (props: any) => {
    const chefForPartyService = new ChefForPartyService();
    const [paymentDialog, setPaymentDialog] = useState(false)
    const [refundTrialModel, setRefundTrialModel] = useState<boolean>(false);
      const [editAmount, setEditAmount] = useState(false);
    const [paymentLinks, setPaymentLinks] = useState<any>();
    const [refundData, setRefundData] = useState<any>()
    const location = useLocation();
    const partyId = location.pathname.split('/')[2]
    const handleSendPayment = (data: any) => {
      EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
        message: "Are you sure you want to send the payment link?",
        onClose: (confirmed: boolean) => {
          if (confirmed) {
            chefForPartyService.sendPaymentLink(Number(partyId), data?.id).then((res) => {
              setPaymentDialog(true);
              setPaymentLinks(res);
              EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Payment link sent",
                type: CustomSnackbarTypes.SUCCESS,
              });
            });
          }
        },
        title: "Confirmation",
      });
    };
    const handleRefund = (data : any) => {
        setRefundTrialModel(true);
        setRefundData(data)
    }
    return (
        <>
        <PaymentLinkDailog
          data={paymentLinks}
          open={paymentDialog}
          callback={(data) => {
            setPaymentDialog(false);
          }}
        />
        <ChefForPartyRefundDailog
            data={refundData}
            open={refundTrialModel}
            refresh={props.refresh}
            callback={() => {
            setRefundTrialModel(false)
            }}
        />
        {editAmount && (
            <EditAmountChefForParty
                id={Number(partyId)}
                data={refundData}
                open={editAmount}
                refresh={props.refresh}
                setOpen={setEditAmount}
            />
        )}
      <TableWrapper>
        <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
          <StyledTable>
            <TableHead>
              <TableRow sx={{ backgroundColor: "rgba(232,235,237,0.3) !important" }}>
                <TableHeader>Id</TableHeader>
                <TableHeader>Order Summary</TableHeader>
                <TableHeader>Amount</TableHeader>
                <TableHeader>Wallet Cash Used</TableHeader>
                <TableHeader>Created At</TableHeader>
                <TableHeader>Status</TableHeader>
                <TableHeader>Razorpay Order Id</TableHeader>
                <TableHeader>Refund Id</TableHeader>
                <TableHeader>Refund Amount</TableHeader>
                <TableHeader></TableHeader>
                <TableHeader></TableHeader>
                <TableHeader></TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.data.map((row: any) => (
                <CustomTableRowTR key={row.id}>
                  <TableData>{row?.id}</TableData>
                  <TableData>{row?.orderSummary}</TableData>
                  <TableData>{row?.amount}</TableData>
                  <TableData>{row?.payment?.orderPayment?.walletBalanceUsed ? row?.payment?.orderPayment?.walletBalanceUsed : 'N/A'}</TableData>
                  <TableData>
                    {formatDateTimeWithSeconds(row?.createdAt)}
                  </TableData>
                  <TableData>
                    {row?.payment?.orderPayment?.paymentStatus || "NOT_PAID"}
                  </TableData>
                  <TableData>
                    {row?.payment?.orderPayment?.razorpayOrderId || "---"}
                  </TableData>
                  <TableData>
                    {row?.payment?.orderPayment?.refundId || "---"}
                  </TableData>
                  <TableData>
                    {row?.payment?.orderPayment?.paymentStatus === PaymentStatusEnum.REFUNDED
                      ? row?.payment?.razorpayOrder?.refundAmount ?? "---"
                      : "---"}
                  </TableData>
                  {(!row?.payment?.orderPayment || row?.payment?.orderPayment?.paymentStatus === "NOT_PAID") && (
                    <TableData>
                      <Button
                        variant={"contained"}
                        onClick={() => handleSendPayment(row)}
                      >
                        Send Payment Link
                      </Button>
                    </TableData>
                  )}
                  {row?.payment?.orderPayment?.paymentStatus === "PAID" && !row?.payment?.orderPayment?.paymentStatus?.refundId && (
                    <TableData>
                      <Button
                        variant={"contained"}
                        onClick={() => handleRefund(row)}
                      >
                        Refund
                      </Button>
                    </TableData>
                  )}
                  <TableData>
                    <Button
                      disabled={
                        row?.payment?.orderPayment?.paymentStatus === PaymentStatusEnum.PAID ||
                        row?.payment?.orderPayment?.paymentStatus === PaymentStatusEnum.REFUNDED ||
                        props?.party?.status === ChefForPartStatusEnum.CANCELLED
                      }
                      variant={"contained"}
                      color={'warning'}
                      onClick={() => {
                        setRefundData(row);
                        setEditAmount(true);
                      }}
                    >
                      Edit Amount
                    </Button>
                  </TableData>
                </CustomTableRowTR>
              ))}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </TableWrapper>
      </>
    );
  };

  export default ChefForPartyOrderList;
